export const ANNOUNCEMENT_MODULE = {
  Global: 0,
  Report: 1,
  Fill: 2,
  XiaoQQuery: 3,
  XiaoQReport: 4,
  SelfServiceAnalysis: 5,
  SelfServiceDownload: 6,
};

export const POPUP_POSITION = {
  BottomRight: 1,
  Center: 2,
};

export const ROUTE_MODULE_MAP = {
  reportList: ANNOUNCEMENT_MODULE.Report,
  report: ANNOUNCEMENT_MODULE.Report,
  reportView: ANNOUNCEMENT_MODULE.Report,
  reportGroup: ANNOUNCEMENT_MODULE.Report,
  reportSetting: ANNOUNCEMENT_MODULE.Report,
  find: ANNOUNCEMENT_MODULE.Report,
  mineTask: ANNOUNCEMENT_MODULE.Fill,
  tasktodo: ANNOUNCEMENT_MODULE.Fill,
  taskdone: ANNOUNCEMENT_MODULE.Fill,
  initprocess: ANNOUNCEMENT_MODULE.Fill,
  myfile: ANNOUNCEMENT_MODULE.Fill,
  datamanagement: ANNOUNCEMENT_MODULE.Fill,
  dataMaintain: ANNOUNCEMENT_MODULE.Fill,
  checkProcess: ANNOUNCEMENT_MODULE.Fill,
  checkData: ANNOUNCEMENT_MODULE.Fill,
  checkForm: ANNOUNCEMENT_MODULE.Fill,
  xiaoQQueryEmbed: ANNOUNCEMENT_MODULE.XiaoQQuery,
  xiaoQEmbedReport: ANNOUNCEMENT_MODULE.XiaoQReport,
  selfServiceAnalysisEmbed: ANNOUNCEMENT_MODULE.SelfServiceAnalysis,
  selfServiceDownloadEmbed: ANNOUNCEMENT_MODULE.SelfServiceDownload,
};

const lastFetchTime = {};
const DEBOUNCE_MS = 30000;

export function getNotTipsKey(module) {
  return module === ANNOUNCEMENT_MODULE.Global
    ? "_EBINOTIPSMESSAGE"
    : `_EBINOTIPSMESSAGE_MODULE_${module}`;
}

export function getModuleByRouteName(routeName) {
  return ROUTE_MODULE_MAP[routeName];
}

export function splitByPopupPosition(messages) {
  const bottomRight = [];
  const center = [];
  (messages || []).forEach((item) => {
    if (item.popupPosition === POPUP_POSITION.Center) {
      center.push(item);
    } else {
      bottomRight.push(item);
    }
  });
  return { bottomRight, center };
}

export async function fetchModuleAnnouncements(api, module) {
  if (localStorage[getNotTipsKey(module)]) {
    return { bottomRight: [], center: [] };
  }
  const now = Date.now();
  if (lastFetchTime[module] && now - lastFetchTime[module] < DEBOUNCE_MS) {
    return null;
  }
  lastFetchTime[module] = now;

  const res = await api.Announcement.GetAnnouncementPopup(module);
  if (res && res.isSuccess && res.data && res.data.length) {
    return splitByPopupPosition(res.data);
  }
  return { bottomRight: [], center: [] };
}
